import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import s from './HomeBanner.css';
import cx from 'classnames';
//Components
import BannerCaption from '../BannerCaption';
import SearchForm from '../SearchForm';
import BookYourCarSkeleton from '../../Skeleton/BookYourCarSkeleton';
import BookYourCar from '../BookYourCar/BookYourCar';

const HomeBannerContent = ({ layoutType, wholeData, infoCollection, getBannerData }) => {

    return (
        <div className={s.container}>
            <div className={s.sectionWidth}>
                {
                    layoutType && layoutType == 2 && <div className={s.pageContainer}>
                        <SearchForm />
                    </div>
                }
                {
                    layoutType && layoutType == 2 && <div className={cx(s.pageContainer, s.pageContainerMb)}>
                        <BannerCaption data={getBannerData} />
                    </div>
                }
            </div>
            {!wholeData.getFindYouCar ? <BookYourCarSkeleton /> :
                <BookYourCar infoCollection={infoCollection} />}
        </div>
    )
}
HomeBannerContent.propTypes = {
    getImageBannerData: PropTypes.shape({
        loading: PropTypes.bool,
        getImageBanner: PropTypes.object
    }),
};
HomeBannerContent.defaultProps = {
    getImageBannerData: {
        loading: true
    },
}

export default injectIntl(withStyles(s)(HomeBannerContent));
